import $ from 'jquery';

const convertToSharerParams = ( params ) => {
	return Object.keys( params ).map( ( key ) => {
		let val = params[ key ];

		if ( true === val ) {
			val = 'yes';
		}
		if ( false === val ) {
			val = 'no';
		}

		return key + '=' + val;
	} ).join( ', ' );
};

// Social buttons stuff
const openSharer = ( url, width, height ) => {
	const left  = ( screen.width / 2 ) - ( width / 2 );
	const top   = ( screen.height / 2 ) - ( height / 2 );
	const share = window.open(
		url,
		'Share',
		convertToSharerParams(
			{
				height,
				width,
				top,
				left,
				toolbar: false,
				menubar: false,
				scrollbars: false,
				resizable: false,
				location: false,
				directories: false,
				status: false,
			},
		),
	);
	share.focus();
};

window.openSharer = openSharer;

$( document ).ready( function() {
	$( 'i.fa-facebook' ).on( 'click', function( evt ) {
		evt.preventDefault();
		openSharer( 'http://www.facebook.com/sharer.php?u=' + window.location, 640, 320 );
	} );

	$( 'i.fa-twitter' ).on( 'click', function( evt ) {
		evt.preventDefault();

		openSharer( 'http://twitter.com/share?url=' + window.location, 640, 460 );
	} );

	$( 'i.fa-google' ).on( 'click', function( evt ) {
		evt.preventDefault();

		openSharer( 'https://plus.google.com/share?url=' + window.location, 640, 650 );
	} );

	$( '.popup' ).click( function( ev ) {
		const newWindow = window.open(
			$( this ).attr( 'href' ),
			$( this ).attr( 'title' ) || 'MyWindow',
			convertToSharerParams(
				{
					scrollbars: true,
					width: 500,
					height: 300,
					top: 10,
					left: 30,
				},
			),
		);

		ev.preventDefault();

		if ( window.focus ) {
			newWindow.focus();
		}
	} );
} );
